










import { Component, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";
import { IToken } from "@/types/index";
@Component({
  components: {}
})
export default class extends Vue {
  @Action("auth/authorize")
  public authorize!: (token: IToken) => void;
  @Action("auth/deauthorize")
  public deauthorize!: () => void;

  public async created() {
    this.deauthorize();
    const token: IToken = {
      token_type: this.$route.query.token_type as string,
      refresh_token: this.$route.query.refresh_token as string,
      access_token: this.$route.query.access_token as string,
      expires_in: parseInt(this.$route.query.expires_in as string)
    };
    await this.authorize(token);
    this.$router.push("/admin/home");
  }
}
